import React from "react";
import { Price } from "../../../components/__simple/_price";

const ProtectionServiceCard = ({
    service,
    lang,
    onClick,
    isPackage = false,
    packageType = null
}) => {
    const getPackageColor = () => {
        if (!packageType) return '#3BD461';
        const type = packageType.toLowerCase();
        if (type.includes('gold') || type.includes('ذهبية') || type.includes('الذهبيه')) return '#FFD700';
        if (type.includes('silver') || type.includes('فضية') || type.includes('الفضيه')) return '#C0C0C0';
        if (type.includes('diamond') || type.includes('ماسية') || type.includes('الماسيه')) return '#B9F2FF';
        if (type.includes('platinum') || type.includes('بلاتينية') || type.includes('البلاتينيه')) return '#E5E4E2';
        return '#3BD461';
    };

    const packageColor = getPackageColor();

    const getServiceIcons = () => {
        const nameEn = (service.ServiceName || "").toLowerCase();
        const nameAr = (service.ServiceNameAR || "").toLowerCase();

        const isTinting = nameEn.includes('tint') || nameEn.includes('shading') || nameAr.includes('تظليل');
        const isProtection = nameEn.includes('protection') || nameAr.includes('حماية') || !!packageType;

        if (isTinting && isProtection) {
            return [packageType ? '/assets/icons/services/protection.svg' : '/assets/icons/services/protection-car.svg', '/assets/icons/services/tinting.svg'];
        } else if (isTinting) {
            return ['/assets/icons/services/tinting.svg'];
        } else {
            return [packageType ? '/assets/icons/services/protection.svg' : '/assets/icons/services/protection-car.svg'];
        }
    };

    const icons = getServiceIcons();
    const serviceName = lang === "ar" ? service.ServiceNameAR : service.ServiceName;

    return (
        <div className="pkg-card" onClick={onClick} style={{ cursor: "pointer", height: "100%", transition: "all 0.2s" }}>
            <div className="pkg-top" style={{ background: packageColor }}></div>
            <div className="pkg-body" style={{ padding: "20px 16px 16px" }}>
                <div className="pkg-header" style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px", alignItems: "center" }}>
                    <span className="tag" style={{ fontSize: "10px", padding: "3px 12px", background: `${packageColor}15`, color: packageColor, borderRadius: "99px", fontWeight: 700 }}>
                        {packageType || (lang === 'ar' ? 'خدمة مميزة' : 'Premium Service')}
                    </span>
                    <span style={{ fontSize: "10px", color: "var(--mute)", fontWeight: 600 }}>
                        {lang === 'ar' ? 'ضمان ممتد' : 'Extended Warranty'}
                    </span>
                </div>

                <div style={{ textAlign: "center", margin: "14px 0" }}>
                    <div style={{ display: 'flex', gap: '0.8rem', alignItems: 'center', justifyContent: 'center', margin: '0 auto', width: '56px', height: '56px', background: `${packageColor}10`, borderRadius: '16px' }}>
                        {icons.map((iconPath, idx) => (
                            <div
                                key={idx}
                                style={{
                                    width: '28px',
                                    height: '28px',
                                    WebkitMaskImage: `url(${iconPath})`,
                                    maskImage: `url(${iconPath})`,
                                    WebkitMaskSize: 'contain',
                                    maskSize: 'contain',
                                    WebkitMaskRepeat: 'no-repeat',
                                    maskRepeat: 'no-repeat',
                                    WebkitMaskPosition: 'center',
                                    maskPosition: 'center',
                                    backgroundColor: packageColor
                                }}
                            />
                        ))}
                    </div>
                </div>

                <h3 className="pkg-name" style={{ fontSize: "15px", fontWeight: 800, color: "var(--text)", margin: "0 0 4px" }}>{serviceName}</h3>

                <div className="pkg-price-row" style={{ fontSize: "11px", color: "var(--mute)", marginBottom: "14px" }}>
                    {lang === 'ar' ? 'يبدأ من ' : 'Starts from '}
                    <strong style={{ fontSize: "17px", fontWeight: 900, color: "var(--text)" }}>
                        <Price price={service.Price} />
                    </strong>
                </div>

                <ul className="pkg-features" style={{ listStyle: "none", padding: 0, margin: "0 0 16px" }}>
                    <li style={{ fontSize: "10px", color: "var(--sub)", padding: "4px 0", display: "flex", alignItems: "center", gap: "6px" }}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={packageColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                        {lang === 'ar' ? 'حماية فائقة للسيارة' : 'Premium car protection'}
                    </li>
                    <li style={{ fontSize: "10px", color: "var(--sub)", padding: "4px 0", display: "flex", alignItems: "center", gap: "6px" }}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={packageColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                        {lang === 'ar' ? 'مواد معتمدة ومقاومة' : 'Certified durable materials'}
                    </li>
                </ul>

                <button className="pill pill-o pill-sm" style={{ width: "100%", justifyContent: "center", border: "1.5px solid var(--border)", background: "transparent", fontWeight: 700, fontSize: "12px" }}>
                    {lang === 'ar' ? 'اختر هذه الباقة' : 'Select Package'}
                </button>
            </div>
        </div>
    );
};

export default ProtectionServiceCard;
